import { Box, Button, Checkbox, Divider, FormControlLabel, FormGroup, Grid, TextField } from "@mui/material";
import Link from "next/link";
import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
import { validateEmail } from "../../helpers/validation";
import useTranslation from "../../hooks/useTranslation";
import cssVars from '../../styles/vars.module.scss'
import PrivacyFiled from "../privacyFiled/privacyFiled";
import { useTheme } from "@mui/material";
import { useAuthStore } from "../../stores/authStore";
import Cookies from 'js-cookie';
import { useMutation } from "@apollo/client";
import { SET_EMAIL_ON_GUEST_CART } from "../../graphql/cart/mutations";

const GuestEmailForm = () => {
    const { t } = useTranslation()

    const [email, setEmail] = useState('')
    const [agree, setAgree] = useState(false)
    const router = useRouter()
    const [formCheck, setFormCheck] = useState(false)
    const setGuestEmail = useAuthStore(state => state.setGuestEmail)
    const [setGuestEmailOnCart] = useMutation(SET_EMAIL_ON_GUEST_CART)
    const cartId = useAuthStore(state => state.cartId)

    const handleSubmit = (e) => {
        e.preventDefault()
        setFormCheck(true)

        if (validateEmail(email) && agree) {
            setGuestEmailOnCart({
                variables: { cart_id: cartId, email }, onCompleted: () => {
                    setGuestEmail("true")
                    router.replace("/checkout?g=true")
                }
            })
        }
    }

    const theme = useTheme()

    return (
        <Box pt={2} pb="40px" px={{ xs: "15px", lg: 5 }} display={router.query.redirect !== "/checkout" ? "none" : "block"}>
            <Divider sx={{ mb: "42px", fontSize: "20px", fontWeight: 600, "&::before, &::after": { borderTop: "2px solid #70707090" } }}>{t("OR")}</Divider>
            <Box mb="20px" sx={{ fontSize: "20px", fontWeight: 600 }}>{t("Continue Without Membership")}</Box>
            <Box component="form" onSubmit={handleSubmit} autoComplete="off">
                <TextField
                    id="guest-email"
                    label={t("Email")}
                    placeholder={t("Email")}
                    fullWidth
                    className="custom-input"
                    type="email"
                    error={formCheck && !validateEmail(email)}
                    onChange={(e) => { setEmail(e.target.value) }}
                />
                <Grid className="form-error" display={formCheck && !validateEmail(email) ? "block" : "none"} sx={{ color: cssVars.red }} >{t("Please enter a valid email.")}</Grid>
                <Box sx={{ mt: "27px" }}>

                </Box>
                <PrivacyFiled checked={agree} formCheck={formCheck} onChange={(e) => { setAgree(e.target.checked) }} forGuest/>
                <Grid className="form-error" display={formCheck && !agree ? "block" : "none"} sx={{ color: cssVars.red }} >{t("Agreeing to terms and privacy is required.")}</Grid>
                <Button fullWidth type="submit" variant="contained"
                    sx={{
                        height: "48px !important",
                        mt: "50px",
                        borderRadius: '25px', bgcolor: theme.palette.primary.main, borderColor: theme.palette.primary.main, color: "#FFF",
                        ":hover": { bgcolor: theme.palette.primary.dark, borderColor: theme.palette.primary.dark, color: "#FFF" }
                    }}
                >
                    {t("Continue")}
                </Button>
            </Box>
        </Box >
    );
}

export default GuestEmailForm;

